import { User } from '@weblite/ts-action/user'
import { getAvatarText } from '$func/avatar-text'
import { t } from '$i18n'

export const getUserAvatarText = (user?: User) => {
  if (!user) return ''
  return user.deletedAt
    ? t('accounts.deletedAccountAvatarText')
    : getAvatarText(user.firstname)
}

export function getUserDisplayName(user?: {
  firstname?: string
  lastname?: string
  deletedAt?: boolean
}): string {
  if (!user) return ''

  return user.deletedAt
    ? t('accounts.deletedAccount')
    : [user.firstname || '', user.lastname || ''].filter(Boolean).join(' ')
}

export function getUserFirstName(user?: User) {
  if (!user) return ''
  return user.deletedAt ? t('accounts.deletedAccount') : user.firstname
}
